import { render, staticRenderFns } from "./ThankYou.vue?vue&type=template&id=4212069e&scoped=true&"
import script from "./ThankYou.vue?vue&type=script&lang=ts&"
export * from "./ThankYou.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4212069e",
  null
  
)

export default component.exports